'use client';

import React, { useState } from 'react';
import { Flex, Box, Text, VStack, Grid, GridItem } from '@skin-seoul/design-system';
import { AnimatePresence, motion } from 'motion/react';
import { Condition } from '@skin-seoul/utils';
import { categories } from '@/components/layout/Header/constants/category';
import { brands, moreBrands } from '@/components/layout/Header/constants/brand';
import { NavItem } from './NavItem';
import { MenuItem } from './MenuItem';
import { chunk } from 'es-toolkit';
import { SafeLink } from '@/components/ui/SafeLink';
import { CLASSNAME } from '@skin-seoul/service';
const MotionFlex = motion.create(Flex);
enum MenuStatus {
  'CLOSED' = 'CLOSED',
  'BRAND' = 'BRAND',
  'PRODUCTS' = 'PRODUCTS',
}
const BOLD_PARENT_CATEGORIES = ['Contour', 'Face Makeup', 'Lip Makeup', 'Eye Makeup', 'Men\'s'];
const FIRST_BOLD_CATEGORY = 'Contour';
function NavBar() {
  const [menuStatus, setMenuStatus] = useState<MenuStatus>(MenuStatus.CLOSED);
  return <Flex alignItems="center" as="ul" backgroundColor="black" color="white" textStyle="body2" height="fit-content" justifyContent="center" listStyleType="none" onMouseLeave={() => setMenuStatus(MenuStatus.CLOSED)} paddingBottom="10px" display={{
    base: 'none',
    tablet: 'flex'
  }} data-sentry-element="Flex" data-sentry-component="NavBar" data-sentry-source-file="HeaderMenu.tsx">
      <SafeLink unstyled href="/" onMouseEnter={() => setMenuStatus(MenuStatus.CLOSED)} data-sentry-element="SafeLink" data-sentry-source-file="HeaderMenu.tsx">
        <NavItem data-sentry-element="NavItem" data-sentry-source-file="HeaderMenu.tsx">Home</NavItem>
      </SafeLink>
      <SafeLink unstyled href="/shop/" onMouseEnter={() => setMenuStatus(MenuStatus.PRODUCTS)} data-sentry-element="SafeLink" data-sentry-source-file="HeaderMenu.tsx">
        <NavItem isMenu isOpen={menuStatus === MenuStatus.PRODUCTS} data-sentry-element="NavItem" data-sentry-source-file="HeaderMenu.tsx">
          Products
        </NavItem>
      </SafeLink>
      <SafeLink unstyled href="/brand/" onMouseEnter={() => setMenuStatus(MenuStatus.BRAND)} data-sentry-element="SafeLink" data-sentry-source-file="HeaderMenu.tsx">
        <NavItem isMenu isOpen={menuStatus === MenuStatus.BRAND} data-sentry-element="NavItem" data-sentry-source-file="HeaderMenu.tsx">
          Brands
        </NavItem>
      </SafeLink>
      <SafeLink unstyled href="/trend/" onMouseEnter={() => setMenuStatus(MenuStatus.CLOSED)} data-sentry-element="SafeLink" data-sentry-source-file="HeaderMenu.tsx">
        <NavItem data-sentry-element="NavItem" data-sentry-source-file="HeaderMenu.tsx">Trending</NavItem>
      </SafeLink>
      <SafeLink unstyled href="/about-us/" onMouseEnter={() => setMenuStatus(MenuStatus.CLOSED)} data-sentry-element="SafeLink" data-sentry-source-file="HeaderMenu.tsx">
        <NavItem data-sentry-element="NavItem" data-sentry-source-file="HeaderMenu.tsx">About Us</NavItem>
      </SafeLink>
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="HeaderMenu.tsx">
        <Condition expression={menuStatus !== MenuStatus.CLOSED} then={<MotionFlex alignItems="center" animate={{
        opacity: 1
      }} backgroundColor="white" borderBottom="1px solid" borderBottomColor="neutral.30" exit={{
        opacity: 0
      }} flexDirection="row" height="fit-content" initial={{
        opacity: 0
      }} justifyContent="center" key="shopByMenu" left="0" maxHeight="fit-content" minHeight="200px" onMouseLeave={() => setMenuStatus(MenuStatus.CLOSED)} paddingX="28px" paddingY="36px" position="absolute" top="100%" transition={{
        duration: 0.1
      }} width="100%" zIndex="banner">
              <Flex alignItems="flex-start" flexDirection="row" height="fit-content" justifyContent="flex-start" maxWidth="1280px" width="100%">
                <Condition expression={menuStatus === MenuStatus.BRAND} then={<Grid gap={6} templateColumns="repeat(3, 1fr)" width="100%">
                      {chunk(brands, Math.floor(brands.length / 3)).map((brand, index) => {
              const brandList = index === 2 ? [...brand, moreBrands] : brand;
              return <GridItem _last={{
                borderRight: 'none'
              }} borderRight="1px solid" borderRightColor="neutral.100" colSpan={1} key={index} paddingLeft="30px" paddingY="10px" width="100%" display="flex" flexDirection="column" gap={3}>
                            {brandList.map(bName => <Box key={bName.name}>
                                <MenuItem href={bName.link}>{bName.name}</MenuItem>
                              </Box>)}
                          </GridItem>;
            })}
                    </Grid>} />

                <Condition expression={menuStatus === MenuStatus.PRODUCTS} then={<Grid gap={6} paddingY="10px" templateColumns="repeat(4, 1fr)" width="100%">
                      {categories.map(category => <GridItem _last={{
              borderRight: 'none'
            }} borderRight="1px solid" borderRightColor="neutral.100" display="flex" flexDirection="column" gap={5} key={category.id} paddingRight="30px">
                          <SafeLink href={category.link} textDecoration="none">
                            <Text color="neutral.900" fontWeight="bold" textStyle="paragraph.medium" className={CLASSNAME.NOT_TRANSLATE}>
                              {category.category}
                            </Text>
                          </SafeLink>
                          <VStack alignItems="flex-start" display="flex" gap={3} justifyContent="flex-start">
                            {category.subCategories.map(subCat => {
                  const isBoldCategory = BOLD_PARENT_CATEGORIES.includes(subCat.name);
                  const addSpacing = subCat.name === FIRST_BOLD_CATEGORY;
                  return <Box key={subCat.name} marginTop={addSpacing ? 5 : 0}>
                                  <MenuItem href={subCat.link} textStyle={isBoldCategory ? 'paragraph.medium' : 'paragraph.small'} fontWeight={isBoldCategory ? 'bold' : 'regular'}>
                                    {subCat.name}
                                  </MenuItem>
                                </Box>;
                })}
                          </VStack>
                        </GridItem>)}
                    </Grid>} />
              </Flex>
            </MotionFlex>} data-sentry-element="Condition" data-sentry-source-file="HeaderMenu.tsx" />
      </AnimatePresence>
    </Flex>;
}
export default NavBar;